<script setup lang="ts">
import { useAuthStore } from "@/store/auth"
import { onMounted } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useI18n } from "vue-i18n"

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const auth = useAuthStore()

onMounted(async () => {
    try {
        await auth.handleAuthCallback(route.query as Record<string, any>)
        await router.replace('/')
    } catch (e) {
        console.error(e)
        auth.clearSession()
        auth.loginRedirect()
    }
})
</script>

<template>
    <div class="p-6">
        <p>{{ t('auth.loggingIn') }}</p>
    </div>
</template>
